export const PRIVACY_POLICY_LINK = 'https://goodstack.org/legal/privacy-policy'
export const TERMS_LINK = 'https://goodstack.org/legal/applicant-validation-terms'
